import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {SwalComponent} from '@sweetalert2/ngx-sweetalert2';
import {SimcardService} from '../services/simcard.service';
import {ActivatedRoute, Router} from '@angular/router';
import {NgxSpinnerService} from 'ngx-spinner';
import { FirmService } from '../services/firm.service';
import { Firms } from '../models/firms';


@Component({
    selector: 'app-firm-simcard',
    templateUrl: './firm-simcard.component.html',
    styleUrls: ['./firm-simcard.component.css']
})
export class FirmSimcardComponent implements OnInit {
    @ViewChild('closeCreateModal') closeCreateModal: ElementRef;
    @ViewChild('closeUpdateModal') closeUpdateModal: ElementRef;
    @ViewChild('errorSwal') private errorSwal: SwalComponent;
    @ViewChild('successSwal') private successSwal: SwalComponent;
    private firmId: string;
    public sims = [];
    public simsFirstDeactive = [];
    public simsSecondsActive = [];
    public firm: any;
    public searchText;
    public selectedId;
    public selectedSim = {firm: new Firms(), serial: '', status: '-1', cell: '', phoneNumber: '', bandwidth: '', operator: '-1'};
    flag: string = '';
    loading = false;
    firms = [];
    firmDetail = [];
    constructor(private simcardService: SimcardService,
                private router: Router,
                private route: ActivatedRoute,
                private firmService: FirmService,
                private spinner: NgxSpinnerService) {
    }

    ngOnInit() {
        this.spinner.show();
        this.firm = localStorage.getItem('firm');
        this.firmId = localStorage.getItem('firmId');
        this.flag = this.route.snapshot.paramMap.get('flag');
        if(this.flag === 'varliklar') {
            this.getSimsForSuperAdmin();
        } else {
            this.getSimByFirm(this.firmId);
        }
        this.getAllFirms();
    }

    getSimByFirm(firmId: string) {
            this.simcardService.getSimCardsByFirm(firmId).subscribe(res => {
                this.sims = [];
                this.simsFirstDeactive = [];
                this.simsSecondsActive = [];
                res.dataSimCards.forEach(data => {
                    if (!data.status) {
                        this.simsFirstDeactive.push(data);
                    } else {
                        this.simsSecondsActive.push(data);
                    }
                });
                this.sims = this.simsFirstDeactive.concat(this.simsSecondsActive);
                this.spinner.hide();
            }, error => {
                if (error.message === 'Error: Access Denied') {
                    localStorage.removeItem('token');
                    localStorage.removeItem('user');
                    this.router.navigate(['/login']);
                    this.spinner.hide();
                } else {
                    this.errorSwal.title = error.status;
                    this.errorSwal.text = error.error;
                    this.errorSwal.show();
                    this.spinner.hide();
                }
            });
    }
    getSimsForSuperAdmin() {
        this.spinner.show();
        this.flag = this.route.snapshot.paramMap.get('flag');
        if (this.flag === 'varliklar') {
            this.simcardService.getSimsForSuperAdmin().subscribe(res => {
                if (res.success) {                    
                    this.sims = [];
                    this.simsFirstDeactive = [];
                    this.simsSecondsActive = [];
                    res.sims.forEach(data => {
                        if (!data.status) {
                            this.simsFirstDeactive.push(data);
                        } else {
                            this.simsSecondsActive.push(data);
                        }
                    });
                    this.sims = this.simsFirstDeactive.concat(this.simsSecondsActive);
                    this.spinner.hide();
                } else {
                    this.errorSwal.title = 'Hata!';
                    this.errorSwal.text = res.message;
                    this.errorSwal.show();
                    this.spinner.hide();
                }
            }, error => {
                if (error.message === 'Error: Access Denied') {
                    localStorage.removeItem('token');
                    localStorage.removeItem('user');
                    this.router.navigate(['/login']);
                    this.spinner.hide();
                } else {
                    this.errorSwal.title = error.status;
                    this.errorSwal.text = error.error;
                    this.errorSwal.show();
                    this.spinner.hide();
                }
            });
        }
    }

    createSimcard(serial, cell, phone, bandwidth, operator, status) {
        if (serial === '' || serial === undefined || cell === '' || cell === undefined ||
            phone === '' || phone === undefined || bandwidth === '' || bandwidth === undefined || operator === '' || operator === '-1') {
            this.errorSwal.title = 'Lütfen boş alan bırakmayınız!';
            this.errorSwal.show();
            return;
        }
        this.spinner.show();
        const Sim = {
            serial: serial, cell: cell, phoneNumber: phone, bandwidth: bandwidth,
            firm: this.firmId, status: status, operator: operator
        };
        this.simcardService.createSim(Sim).subscribe(res => {
            this.spinner.hide();
            this.successSwal.title = 'Başarılı!';
            this.successSwal.show();
            this.closeCreateModal.nativeElement.click();
            if(this.flag === 'varliklar') {
                this.getSimsForSuperAdmin();
            } else {
                this.getSimByFirm(this.firmId);
            }
        }, error => {
            if (error.message === 'Error: Access Denied') {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                this.router.navigate(['/login']);
                this.spinner.hide();
            } else {
                this.errorSwal.title = error.status;
                this.errorSwal.text = error.error;
                this.errorSwal.show();
                this.spinner.hide();
            }
        });
    }

    updateSimcard(serial, cell, phone, bandwidth, operator, status) {
        if (serial === '' || serial === undefined || cell === '' || cell === undefined ||
            phone === '' || phone === undefined || bandwidth === '' || bandwidth === undefined || operator === '' || operator === '-1' || status === '' || status === '-1') {
            this.errorSwal.title = 'Lütfen boş alan bırakmayınız!';
            this.errorSwal.show();
            return;
        }
        this.spinner.show();
        const Sim = {
            serial: serial, cell: cell, phoneNumber: phone, bandwidth: bandwidth,
            firm: this.firmId, status: status, operator: operator
        };
        this.simcardService.updateSim(Sim, this.selectedId).subscribe(res => {
            this.spinner.hide();
            this.successSwal.title = 'Başarılı!';
            this.successSwal.show();
            this.closeUpdateModal.nativeElement.click();
            if(this.flag === 'varliklar') {
                this.getSimsForSuperAdmin();
            } else {
                this.getSimByFirm(this.firmId);
            }
        }, error => {
            if (error.message === 'Error: Access Denied') {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                this.router.navigate(['/login']);
                this.spinner.hide();
            } else {
                this.errorSwal.title = error.status;
                this.errorSwal.text = error.error;
                this.errorSwal.show();
                this.spinner.hide();
            }
        });
    }

    getSimById(id) {
        this.spinner.show();
        this.simcardService.getSimById(id).subscribe(res => {
            if (res.success) {
                this.selectedSim = res.sim;
                this.spinner.hide();
            } else {
                this.errorSwal.title = 'Hata!';
                this.errorSwal.text = res.message;
                this.errorSwal.show();
                this.spinner.hide();
            }
        }, error => {
            if (error.message === 'Error: Access Denied') {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                this.router.navigate(['/login']);
                this.spinner.hide();
            } else {
                this.errorSwal.title = error.status;
                this.errorSwal.text = error.error;
                this.errorSwal.show();
                this.spinner.hide();
            }
        });
    }

    selected(id) {
        this.selectedId = id;
        this.getSimById(id);
    }

    deleteSimcard(id) {
        if (id === '' || id === undefined) {
            this.errorSwal.title = 'Simcard id alınamadı!';
            this.errorSwal.show();
            return;
        }
        this.spinner.show();
        this.simcardService.deleteSim(id).subscribe(res => {
            this.spinner.hide();
            this.successSwal.title = 'Başarılı!';
            this.successSwal.show();
            if(this.flag === 'varliklar') {
                this.getSimsForSuperAdmin();
            } else {
                this.getSimByFirm(id);
            }
        }, error => {
            if (error.message === 'Error: Access Denied') {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                this.router.navigate(['/login']);
                this.spinner.hide();
            } else {
                this.errorSwal.title = error.status;
                this.errorSwal.text = error.error;
                this.errorSwal.show();
                this.spinner.hide();
            }
        });
    }

    getAllFirms() {
        this.firmService.getAllFirms().subscribe(res => {
            if (res.success) {
                this.firms = res.firms;
                for (const firm of this.firms) {
                    this.firmDetail.push(firm._id);
                }
            }
        }, error => {
            if (error.message === 'Error: Access Denied') {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                this.router.navigate(['/login']);
            } else {
                this.errorSwal.title = error.status;
                this.errorSwal.text = error.error;
                this.errorSwal.show();
            }
        });
    }
    onSelectSimCreate() {
        this.firmId = this.selectedSim.firm._id;
    }
    onSelectSimUpdate() {
        this.firmId = this.selectedSim.firm._id;
    }
    getOperatorName(id: number) {
        let name = 'unKnown';
        switch (id) {
            case 0:
                name = 'Türk Telekom';
                break;
            case 1:
                name = 'Turkcell';
                break;
            case 2:
                name = 'Vodafone';
                break;
            default:
                name = 'unKnown';
                break;
        }
        return name;
    }
}



// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/firm-simcard/firm-simcard.component.ts